import { createReducer, on } from "@ngrx/store";
import {
  ADD_ASSET,
  ADD_IMAGE,
  ADD_ACTION,
  ADD_ACTIONS,
  ADD_FINDINGS,
  UPDATE_ASSET,
  ADD_ASSESMENT,
  UPDATE_ACTION,
  ADD_ASSESMENTS,
  UPDATE_FINDING,
  UPDATE_ASSESMENT,
  UPDATE_ASSESMENTS,
  ADD_ASSESSMENT_SITE,
  ADD_SITE_ASSESSMENTS,
  REMOVE_ALL_ASSESMENTS,
  UPDATE_ASSESSMENT_SITE,
  REMOVE_ASSESSMENT_SITE,
} from "../actions/assessment.action";
import { ADD_FINDING } from "../actions/finding.action";
import {
  AssessmentModel,
  SiteAssessmentFindingsActionsModel,
} from "../models/assesment.model";
import { AssetModel, SiteModel } from "../models/asset.model";

const INITIAL_STATE_SITE: SiteModel = {};
const INITIAL_STATE: AssessmentModel[] = [];
const INITIAL_STATE_ASSESMENT: AssessmentModel = {} as AssessmentModel;
const INITIAL_SITE_ASSESSMENTS: SiteAssessmentFindingsActionsModel =
  {} as SiteAssessmentFindingsActionsModel;

function updateAssets(
  updatedAsset: AssetModel,
  currentAssets: AssetModel[],
): AssetModel[] {
  const existingAssetIndex = currentAssets.findIndex(
    (asset) => asset.uid === updatedAsset.uid,
  );
  if (existingAssetIndex === -1) {
    return [...currentAssets, updatedAsset];
  }
  return currentAssets.map((asset) =>
    asset.uid === updatedAsset.uid ? { ...asset, ...updatedAsset } : asset,
  );
}
export const AssesmentReducer = createReducer(
  INITIAL_STATE_ASSESMENT,
  on(ADD_ASSESMENT, (_, assesment) => assesment),
  on(UPDATE_ASSESMENT, (state, { assesment }) => ({ ...state, ...assesment })),

  on(ADD_FINDING, (state, finding) => ({
    ...state,
    findings: [...(state.findings || []), finding],
  })),
  on(ADD_ACTION, (state, action) => ({
    ...state,
    actions: [...(state.actions || []), action],
  })),
  on(ADD_IMAGE, (state, action) => ({
    ...state,
    actions: [...(state.actions || []), action],
  })),
  on(ADD_FINDINGS, (state, { findings }) => ({
    ...state,
    findings: [...findings],
    // findings: [...(state.findings || []), ...findings],
  })),
  on(ADD_ACTIONS, (state, { actions }) => ({
    ...state,
    actions: [...actions],
    // actions: [...(state.actions || []), ...actions],
  })),
  on(UPDATE_FINDING, (state, { finding }) => ({
    ...state,
    findings: (state.findings || []).map((prevFinding) =>
      prevFinding.id === finding.id
        ? { ...prevFinding, ...finding }
        : prevFinding,
    ),
  })),
  on(UPDATE_ACTION, (state, { action }) => ({
    ...state,
    actions: (state.actions || []).map((prevAction) =>
      prevAction.id === action.id ? { ...prevAction, ...action } : prevAction,
    ),
  })),
);

export const AssesmentsReducer = createReducer(
  INITIAL_STATE,
  on(ADD_ASSESMENTS, (_, { assesments }) => assesments),
  on(UPDATE_ASSESMENTS, (state, { assesment }) => {
    const _assesment = state.map((stateAssesment) =>
      stateAssesment?.id === assesment?.id
        ? { ...stateAssesment, ...assesment }
        : stateAssesment,
    );

    const assessmentExists = state.find(
      (stateAssesment) => stateAssesment?.id === assesment?.id,
    );
    return assessmentExists ? _assesment : [assesment, ..._assesment];
  }),
  on(REMOVE_ALL_ASSESMENTS, () => []),
);

export const AssessmentSiteReducer = createReducer(
  INITIAL_STATE_SITE,
  on(ADD_ASSESSMENT_SITE, (_, site) => site),
  on(ADD_ASSET, (state, asset) => ({
    ...state,
    assets: [...(state.assets || []), asset],
  })),

  on(UPDATE_ASSET, (state, asset) => ({
    ...state,
    assets: updateAssets(asset, state.assets || []),
  })),

  on(UPDATE_ASSESSMENT_SITE, (state, site) => ({ ...state, ...site })),
  on(REMOVE_ASSESSMENT_SITE, () => ({})),
);

export const SiteAssessmentsReducer = createReducer(
  INITIAL_SITE_ASSESSMENTS,
  on(ADD_SITE_ASSESSMENTS, (_, { assessment }) => assessment),
);
